import React from 'react';

export default function ScanWaiting({ title, detail }) {
  return (
    // Announced, not just drawn. A screen-reader user gets no signal at all from a spinner.
    <div
      role="status"
      aria-live="polite"
      // Centred in the space the table will fill, not parked under the tabs. A fixed top padding
      // put it in the upper third of an otherwise empty page, which reads as content that has
      // started rendering rather than a page that is waiting.
      /**
       * CENTRED ON THE PAGE, not on the space left under the tabs.
       *
       * The block starts about 203px down - page title, subtitle, tab bar. Centring inside
       * whatever is left below that puts the spinner well under the middle of the screen, which is
       * how `60vh` measured: 49px low. Subtracting TWICE that offset from the viewport height makes
       * the block's own midpoint land on the viewport's, at any window size.
       */
      className="min-h-[calc(100vh-406px)] flex flex-col items-center justify-center text-center"
    >
      <div
        aria-hidden="true"
        className="w-11 h-11 mb-5 rounded-full border-4 border-[#e6f1ff] border-t-[#0089ff] animate-spin [animation-duration:900ms] motion-reduce:animate-none"
      />
      <p className="text-[17px] font-semibold text-[#0f172a] mb-1.5">{title}</p>
      <p className="text-sm text-[#64748b]">{detail}</p>
    </div>
  );
}
